const metafieldsEl = document.querySelector('#product-metafields');
let metafields;
if (metafieldsEl) {
  metafields = JSON.parse(metafieldsEl.textContent).metafields;
}

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export default function setBuilderFormState() {
  const cartForm = document.querySelector('form[action="/cart/add"][id*="product_form"]');
  const formData = new FormData(cartForm);
  const product = JSON.parse(cartForm.parentElement.dataset.product);

  // get package option index from product
  const packageIndex = product.options.findIndex((option) => option === 'Package');
  // get package option value
  const packageValue = formData.get(`option-${packageIndex}`);
  if (packageValue) {
    const packagePriceInt = metafields.packages[`${packageValue.toLowerCase()}_package_price`];
    const formattedPackagePrice = formatter.format(packagePriceInt / 100);

    // update package prices
    const packagePriceEl = document.querySelector('.builder-costs .package-price');
    const subtotalEl = document.querySelector('.builder-costs .subtotal');
    packagePriceEl.textContent = formattedPackagePrice;
    if (subtotalEl) {
      subtotalEl.textContent = formattedPackagePrice;
    }
  }
}
